import { timestamps, uuid } from '@snap-types/models/common';
import { z } from 'zod/v4';

import { erpDBSchema } from './enums';

export const columns = {
  uuid: uuid,

  code: z.string(),
  specialization: z.array(z.string()),

  name: z.string(),

  erpDB: erpDBSchema,

  snapSiteConfigUuid: uuid.nullish(),

  ...timestamps,
};
